import { jsx } from 'react/jsx-runtime';
import { mergeStyleSets, CommandBarButton, NeutralColors } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useHydration } from '@agoras/hooks';

var classNames = mergeStyleSets({
    button: {
        height: '100%'
    }
});
var AllButton = function(param) {
    var isOpen = param.isOpen, dismissPanel = param.dismissPanel, openPanel = param.openPanel, componentRef = param.componentRef, _param_renderText = param.renderText, renderText = _param_renderText === void 0 ? true : _param_renderText;
    var iconName = isOpen ? 'Cancel' : 'GlobalNavButton';
    var t = useTranslation('header').t;
    var isHydrated = useHydration();
    var ariaLabel = isOpen ? t('Close all panel button') : t('Open all panel button');
    var text = renderText ? t('All') : undefined;
    var onClick = isOpen ? dismissPanel : openPanel;
    return /*#__PURE__*/ jsx(CommandBarButton, {
        ariaLabel: ariaLabel,
        text: text,
        onClick: onClick,
        className: classNames.button,
        disabled: !isHydrated,
        componentRef: function(ref) {
            if (componentRef) {
                componentRef.current = ref;
            }
        },
        iconProps: {
            iconName: iconName,
            // Due to styling order issue, using 'style' instead of 'styles' is necessary here
            style: {
                color: NeutralColors.gray160
            }
        }
    });
};

export { AllButton as default };
